/**
 * 공통 로그인 유틸리티 - 모든 앱에서 사용
 * DRY 원칙: edusense-frontend, reward-app, meditation-app, reward-business 통합
 * 
 * @example
 * ```typescript
 * import { startGeminiLogin } from '@edusense/shared-auth-core';
 * 
 * // 모든 앱에서 동일하게 사용
 * const handleLogin = () => startGeminiLogin('ko');
 * ```
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React from 'react';
import { generateCodeVerifier, generateCodeChallenge } from './pkce';
import { generateOAuthState, buildAuthorizationUrl } from './oauth2';
// Tauri 기본 API를 활용한 플랫폼 감지 - Issue #409 패턴 (별도 패키지 유지)
import { getOAuth2RedirectUriSync, getCancelUriSync, logPlatformInfo } from '@edusense/shared-platform-detection';
/**
 * 기본 앱 설정들
 */ export var APP_CONFIGS = {
    'edusense-frontend': {
        displayName: 'Edusense',
        displayIcon: 'https://app.ugot.uk/images/favicon-edsense.ico',
        purpose: 'AI 튜터를 통해 맞춤형 학습 지원을 제공하기 위해',
        features: [
            '1:1 맞춤 학습 지도',
            '과제 피드백',
            '개념 설명',
            '학습 진도 분석'
        ]
    },
    'reward-app': {
        displayName: 'Edusense Reward',
        displayIcon: 'https://reward.ugot.uk/images/favicon-reward.ico',
        purpose: '학습 성과에 따른 리워드 시스템을 제공하기 위해',
        features: [
            '성과 추적',
            '리워드 지급',
            '랭킹 시스템',
            '동기부여 도구'
        ]
    },
    'meditation-app': {
        displayName: 'Edusense Meditation',
        displayIcon: 'https://meditation.ugot.uk/images/favicon-meditation.ico',
        purpose: '명상과 마음챙김을 통한 학습 집중력 향상을 위해',
        features: [
            '명상 가이드',
            '집중력 훈련',
            '스트레스 관리',
            '학습 컨디션 조절'
        ]
    },
    'reward-business': {
        clientId: 'reward-business-client',
        displayName: 'Edusense Business',
        displayIcon: 'https://business.ugot.uk/images/favicon-business.ico',
        purpose: '기업 교육 및 팀 학습 관리를 제공하기 위해',
        features: [
            '팀 관리',
            '교육 과정 설계',
            '성과 분석',
            '기업 대시보드'
        ]
    },
    'whisper-frontend': {
        displayName: 'UGOT Whisper',
        displayIcon: 'https://freestt.ugot.uk/favicon.ico',
        purpose: 'GPU 기반 음성-텍스트 전환 서비스를 안전하게 제공하기 위해',
        features: [
            '대용량 Whisper Large-v3 추론',
            '사용자별 전송 기록 보호',
            'OAuth2 기반 접근 제어',
            'GPU 큐 상태 모니터링'
        ]
    }
};
/**
 * 🚀 모든 앱에서 사용하는 통합 OAuth 로그인 시작 함수
 * 
 * MainPage의 handleSharedOAuthLogin과 동일한 기능을 제공하되,
 * 앱별 설정을 받아서 각 앱에 맞게 OAuth 플로우를 시작합니다.
 * 
 * @param currentLang - 현재 언어 ('ko', 'en' 등)
 * @param appName - 앱 이름 ('edusense-frontend', 'reward-app' 등)
 * @param customConfig - 커스텀 앱 설정 (선택)
 */ export var startOAuthLogin = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(currentLang) {
        var appName, customConfig, baseConfig, config, preOAuthStorage, codeVerifier, codeChallenge, state, supportedLangs, pathSegments, pathLang, normalizedLang, buildLocalizedPath, currentUrl, redirectParam, originalCandidate, postLoginTarget, REDIRECT_URI, AUTH_SERVER_URL, oauth2Config, oauth2Params, authUrl, postOAuthStorage, error;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    appName = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 'edusense-frontend', customConfig = _arguments.length > 2 ? _arguments[2] : void 0;
                    console.log("[SharedLogin] \uD83D\uDE80 통합 로그인 시작 - 앱: ".concat(appName, ", 언어: ").concat(currentLang));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    // 앱별 설정 적용
                    baseConfig = APP_CONFIGS[appName];
                    if (!baseConfig) {
                        throw new Error("Unknown app: ".concat(appName, ". Available apps: ").concat(Object.keys(APP_CONFIGS).join(', ')));
                    }
                    config = _object_spread({}, baseConfig, customConfig);
                    console.log("[SharedLogin] 앱 설정:", {
                        appName: appName,
                        displayName: config.displayName,
                        purpose: config.purpose,
                        featuresCount: config.features.length
                    });
                    // 🚀 플랫폼 감지 및 로깅
                    logPlatformInfo(appName);
                    // OAuth 요청 직전 디버깅 로깅
                    console.log('[SharedLogin] OAuth 요청 직전 상태:', {
                        currentLang: currentLang,
                        appName: appName,
                        pathname: window.location.pathname,
                        fullPath: window.location.href,
                        hasLocalStorage: !!window.localStorage,
                        hasCrypto: !!window.crypto,
                        isSecureContext: window.isSecureContext
                    });
                    // localStorage 초기 상태 확인
                    preOAuthStorage = {
                        oauth2_state: localStorage.getItem('oauth2_state'),
                        pkce_code_verifier: localStorage.getItem('pkce_code_verifier'),
                        storageLength: localStorage.length
                    };
                    console.log('[SharedLogin] OAuth 요청 전 localStorage 상태:', preOAuthStorage);
                    // PKCE 코드 생성
                    codeVerifier = generateCodeVerifier();
                    return [
                        4,
                        generateCodeChallenge(codeVerifier)
                    ];
                case 2:
                    codeChallenge = _state.sent();
                    state = generateOAuthState();
                    // 로그인 이후 이동해야 할 경로 저장 (언어별 홈 화면 기본값)
                    try {
                        supportedLangs = [
                            'ko',
                            'en',
                            'ja'
                        ];
                        pathSegments = window.location.pathname.split('/');
                        pathLang = pathSegments[1];
                        normalizedLang = supportedLangs.includes(currentLang) ? currentLang : supportedLangs.includes(pathLang) ? pathLang : 'ko';
                        buildLocalizedPath = function(rawPath) {
                            if (!rawPath || rawPath === '/') {
                                return "/".concat(normalizedLang, "/home");
                            }
                            if (/^https?:\/\//.test(rawPath)) {
                                return rawPath;
                            }
                            var normalized = rawPath.startsWith('/') ? rawPath : "/".concat(rawPath);
                            var loginPattern = new RegExp("^/(?:".concat(normalizedLang, ")?/login/?$"));
                            if (loginPattern.test(normalized) || normalized === "/".concat(normalizedLang)) {
                                return "/".concat(normalizedLang, "/home");
                            }
                            if (/^\/(?:ko|en|ja)\//.test(normalized)) {
                                return normalized;
                            }
                            return "/".concat(normalizedLang).concat(normalized);
                        };
                        currentUrl = new URL(window.location.href);
                        redirectParam = currentUrl.searchParams.get('redirect') || currentUrl.searchParams.get('returnTo') || currentUrl.searchParams.get('next');
                        originalCandidate = redirectParam && redirectParam.trim().startsWith('/') ? redirectParam.trim() : "".concat(window.location.pathname).concat(window.location.search);
                        postLoginTarget = buildLocalizedPath(originalCandidate);
                        localStorage.setItem('oauth2_post_login_redirect', postLoginTarget);
                        localStorage.setItem('oauth2_post_login_lang', normalizedLang);
                    } catch (redirectError) {
                        console.warn('[SharedLogin] Failed to prepare post-login redirect info:', redirectError);
                        localStorage.removeItem('oauth2_post_login_redirect');
                        localStorage.removeItem('oauth2_post_login_lang');
                    }
                    // localStorage에 PKCE 정보 저장
                    localStorage.setItem('pkce_code_verifier', codeVerifier);
                    localStorage.setItem('oauth2_state', state);
                    // 🚀 플랫폼별 Redirect URI 가져오기 (Tauri 모바일 지원)
                    REDIRECT_URI = getOAuth2RedirectUriSync(appName);
                    AUTH_SERVER_URL = import.meta.env.VITE_AUTH_SERVER_URL || 'https://auth.ugot.uk';
                    console.log("[SharedLogin] \uD83C\uDFAF 플랫폼별 Redirect URI:", {
                        appName: appName,
                        redirectUri: REDIRECT_URI,
                        cancelUri: getCancelUriSync(appName)
                    });
                    // OAuth2 설정 객체 
                    oauth2Config = {
                        authServerUrl: AUTH_SERVER_URL,
                        clientId: config.clientId || 'app-client',
                        redirectUri: REDIRECT_URI,
                        responseType: 'code',
                        scopes: [
                            'openid',
                            'profile',
                            'email',
                            'api.read',
                            'offline_access'
                        ].concat(_to_consumable_array(config.scopes || []))
                    };
                    // OAuth2 플로우 파라미터
                    oauth2Params = {
                        state: state,
                        provider: 'internal',
                        lang: currentLang,
                        displayName: config.displayName,
                        displayIcon: config.displayIcon
                    };
                    // 🚀 올바른 방식으로 buildAuthorizationUrl 호출 (3개 파라미터)
                    authUrl = buildAuthorizationUrl(oauth2Config, oauth2Params, codeChallenge);
                    console.log("[SharedLogin] \uD83D\uDD17 Generated OAuth URL with params:", {
                        authServerUrl: oauth2Config.authServerUrl,
                        clientId: oauth2Config.clientId,
                        redirectUri: oauth2Config.redirectUri,
                        scopes: oauth2Config.scopes,
                        state: oauth2Params.state,
                        lang: oauth2Params.lang
                    });
                    console.log("[SharedLogin] \uD83D\uDD17 OAuth Authorization URL:", authUrl);
                    // OAuth2 authserver로 리다이렉트
                    window.location.href = authUrl;
                    // OAuth 요청 후 localStorage 상태 확인
                    postOAuthStorage = {
                        oauth2_state: localStorage.getItem('oauth2_state'),
                        pkce_code_verifier: localStorage.getItem('pkce_code_verifier'),
                        storageLength: localStorage.length
                    };
                    console.log('[SharedLogin] OAuth 요청 후 localStorage 상태:', postOAuthStorage);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error('[SharedLogin] OAuth 요청 중 에러 발생:', {
                        error: error.message,
                        stack: error.stack,
                        name: error.name,
                        appName: appName,
                        currentLang: currentLang,
                        pathname: window.location.pathname
                    });
                    // 에러 발생해도 사용자에게 피드백 제공
                    throw new Error("OAuth 요청 중 오류가 발생했습니다: ".concat(error.message));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function startOAuthLogin(currentLang) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * edusense-frontend 전용 래퍼 함수 (기존 호환성)
 * 
 * @deprecated 직접 startOAuthLogin 사용 권장
 */ export var handleSharedOAuthLogin = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(currentLang) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                startOAuthLogin(currentLang, 'edusense-frontend')
            ];
        });
    });
    return function handleSharedOAuthLogin(currentLang) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 기존 Gemini 이름 호환성 유지 (곧 제거 예정)
 * 
 * @deprecated startOAuthLogin 사용 권장
 */ export var startGeminiLogin = startOAuthLogin;
/**
 * 기존 Gemini 이름 호환성 유지 (곧 제거 예정)
 * 
 * @deprecated handleSharedOAuthLogin 사용 권장
 */ export var handleSharedGeminiLogin = handleSharedOAuthLogin;
/**
 * React Hook 버전
 * 
 * @example
 * ```typescript
 * const { startLogin, isLoading } = useSharedOAuthLogin('reward-app');
 * 
 * <Button onClick={() => startLogin('ko')}>
 *   로그인
 * </Button>
 * ```
 */ export var useSharedOAuthLogin = function(appName) {
    var _React_useState = _sliced_to_array(React.useState(false), 2), isLoading = _React_useState[0], setIsLoading = _React_useState[1];
    var startLogin = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(currentLang, customConfig) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            startOAuthLogin(currentLang, appName, customConfig)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("[useSharedOAuthLogin] ".concat(appName, " 로그인 에러:"), error);
                        throw error;
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function startLogin(currentLang, customConfig) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        startLogin: startLogin,
        isLoading: isLoading
    };
};
/**
 * 기존 이름 호환성 유지 (곧 제거 예정)
 * 
 * @deprecated useSharedOAuthLogin 사용 권장
 */ export var useSharedLogin = useSharedOAuthLogin;
